import moment from 'moment';
export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val;
}

export function getPathParams(search) {
  let obj = {},
    item,
    i = 0,
    len,
    arr = [];
  if (!search) {
    return obj;
  }
  search = search.replace(/\?/, '');
  arr = search.split('&');
  len = arr.length;

  for (;i < len; i++) {
    item = arr[i].split('=');
    obj[item[0]] = decodeURI(item[1]);
  }
  return obj;
}
export function getTimeDistance(type) {
  const now = new Date();
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === 'today') {
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);
    return [moment(now), moment(now.getTime() + (oneDay - 1000))];
  }

  if (type === 'week') {
    let day = now.getDay();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = now.getTime() - (day * oneDay);

    return [moment(beginTime), moment(beginTime + ((7 * oneDay) - 1000))];
  }

  if (type === 'month') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, 'months');
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    return [moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`), moment(moment(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000)];
  }

  if (type === 'year') {
    const year = now.getFullYear();

    return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
  }
}

export function getPlainNode(nodeList, parentPath = '') {
  const arr = [];
  nodeList.forEach((node) => {
    const item = node;
    item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/');
    item.exact = true;
    if (item.children && !item.component) {
      arr.push(...getPlainNode(item.children, item.path));
    } else {
      if (item.children && item.component) {
        item.exact = false;
      }
      arr.push(item);
    }
  });
  return arr;
}

export function digitUppercase(n) {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  let num = Math.abs(n);
  let s = '';
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '');
  });
  s = s || '整';
  num = Math.floor(num);
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = '';
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }

  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
}

function getRelation(str1, str2) {
  if (str1 === str2) {
    console.warn('Two path are equal!');  // eslint-disable-line
  }
  const arr1 = str1.split('/');
  const arr2 = str2.split('/');
  if (arr2.every((item, index) => item === arr1[index])) {
    return 1;
  } else if (arr1.every((item, index) => item === arr2[index])) {
    return 2;
  }
  return 3;
}

export function getElementViewTop(element) {
  let actualTop = element.offsetTop;
  let current = element.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  let elementScrollTop = 0;
  if (document.compatMode === 'BackCompat') {
    elementScrollTop = document.body.scrollTop;
  } else {
    elementScrollTop = document.documentElement.scrollTop;
  }

  return actualTop - elementScrollTop;
}

export function getClientHeight() {
  return window.innerHeight
      || document.documentElement.clientHeight
      || document.body.clientHeight;
}

export function getClientWidth() {
  return window.innerWidth
      || document.documentElement.clientWidth
      || document.body.clientWidth;
}

export function getRoutes(path, routerData) {
  let routes = Object.keys(routerData).filter(routePath =>
    routePath.indexOf(path) === 0 && routePath !== path);
  routes = routes.map(item => item.replace(path, ''));
  let renderArr = [];
  renderArr.push(routes[0]);
  for (let i = 1; i < routes.length; i += 1) {
    let isAdd = false;
    isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3);
    renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1);
    if (isAdd) {
      renderArr.push(routes[i]);
    }
  }
  const renderRoutes = renderArr.map((item) => {
    const exact = !routes.some(route => route !== item && getRelation(route, item) === 1);
    return {
      key: `${path}${item}`,
      path: `${path}${item}`,
      component: routerData[`${path}${item}`].component,
      exact,
    };
  });
  return renderRoutes;
}
/**
 * 获取时间格式 如  2018-01-08
 */
export function getDayTime(date) {
  return moment(date).format('YYYY-MM-DD');
}

/**
 * 获取时间格式 如  2018-01-08 12:12:20
 * @param {*} date
 */
export function getSecondTime(date) {
  return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * 时间格式展示规则：
 * 今天，显示“hh:mm”(24小时制)
 * 昨天,显示“昨天 hh:mm”,
 * 昨天0点~今年1月1日0点，显示“mm-dd hh:mm”
 * 今年1月1日0点之前，显示“yy-mm-dd”
 * @param {*} dateString，日期字符串如2018-01-08 12:12:20
 */
export function getFormattedTime(dateString) {
  const inputDate = moment(dateString).format('YYYY-MM-DD');
  const inputTime = moment(dateString).format('HH:mm');
  const now = moment().format('YYYY-MM-DD');
  const yesterday = moment(now).subtract(1, 'days').format('YYYY-MM-DD');
  if (moment(inputDate).isSame(now)) {
    return inputTime;
  // } else if (moment(inputDate).isBetween(now, yesterday)) {
  } else if (moment(inputDate).isSame(yesterday)) {
    return `昨天 ${inputTime}`;
  } else if (moment(inputDate).isBefore(now, 'year')) {
    return `${inputDate} ${inputTime}`;
  } else if (moment(inputDate).isAfter(now, 'year')) {
    return `${inputDate} ${inputTime}`;
  } else {
    return `${moment(inputDate).format('MM-DD')} ${inputTime}`;
  }
}

/**
 * 计算字符串的宽度
 * @param {*} str，需计算的字符串
 * @param {*} strFontSize，字体大小
 */
export function calcStringPixelsCount(str, strFontSize) {
  if (!str) {
    return 0;
  }

  const stringCharsCount = str.length;
  let stringPixelsCount = 0;
  const elementPixelsLengthRuler = document.createElement('span');
  elementPixelsLengthRuler.style.fontSize = strFontSize;
  elementPixelsLengthRuler.style.visibility = 'hidden';
  elementPixelsLengthRuler.style.display = 'inline-block';
  elementPixelsLengthRuler.style.wordBreak = 'break-all !important';
  document.body.appendChild(elementPixelsLengthRuler);
  for (let i = 0; i < stringCharsCount; i++) {
    if (str[i] === ' ') {
      elementPixelsLengthRuler.innerHTML = '&nbsp;';
    } else {
      elementPixelsLengthRuler.innerHTML = str[i];
    }
    stringPixelsCount += elementPixelsLengthRuler.offsetWidth;
  }
  return stringPixelsCount;
}

export function getCookie(name) {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  if (match){
    return match[1];
  } 
}
export function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${(value || '')}${expires}; path=/`;
}

/**
 * 校验邮箱格式是否正确
 * @param {*} email 需校验的字符串
 */
export function validateEmail(email) {
  const reg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
  return reg.test(email.trim());
}

/**
 * 校验银行卡号是否合法
 * @param {*} bankno 待校验的银行卡号
 */
export function validateBankNo(bankno) {
  const bankNo = bankno.replace(/\s/g, '');
  if (bankNo === "") {
    return false;
  }
  if (bankNo.length < 16 || bankNo.length > 19) {
    return false;
  }
  const num = /^\d*$/;
  if (!num.exec(bankNo)) {
    return false;
  }
  const strBin = "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
  if (strBin.indexOf(bankNo.substring(0, 2)) === -1) {
    return false;
  }
  if (!luhnCheck(bankNo)) {
    return false;
  }
  return true;
}

// 银行卡号luhn校验算法
function luhnCheck(bankno) {
  const lastNum = bankno.substr(bankno.length - 1, 1);
  const first15Num = bankno.substr(0, bankno.length - 1);
  let newArr = [];
  for (var i = first15Num.length - 1; i > -1; i--) {
    newArr.push(first15Num.substr(i, 1));
  }
  let arrJiShu = [];
  let arrJiShu2 = [];
  let arrOuShu = [];
  for (let j = 0; j < newArr.length; j++) {
    if ((j + 1) % 2 === 1) {
      if (parseInt(newArr[j], 10) * 2 < 9) {
        arrJiShu.push(parseInt(newArr[j], 10) * 2);
      } else {
        arrJiShu2.push(parseInt(newArr[j], 10) * 2);
      }
    } else {
      arrOuShu.push(newArr[j]);
    }
  }

  let jishu_child1 = [];
  let jishu_child2 = [];
  for (let h = 0; h < arrJiShu2.length; h++) {
    jishu_child1.push(parseInt(arrJiShu2[h], 10) % 10);
    jishu_child2.push(parseInt(arrJiShu2[h], 10) / 10);
  }
  let sumJiShu = 0;
  let sumOuShu = 0;
  let sumJiShuChild1 = 0;
  let sumJiShuChild2 = 0;
  let sumTotal = 0;
  for (let m = 0; m < arrJiShu.length; m++) {
    sumJiShu = sumJiShu + parseInt(arrJiShu[m], 10);
  }
  for (let n = 0; n < arrOuShu.length; n++) {
    sumOuShu = sumOuShu + parseInt(arrOuShu[n], 10);
  }
  for (let p = 0; p < jishu_child1.length; p++) {
    sumJiShuChild1 = sumJiShuChild1 + parseInt(jishu_child1[p], 10);
    sumJiShuChild2 = sumJiShuChild2 + parseInt(jishu_child2[p], 10);
  }
  sumTotal = parseInt(sumJiShu, 10) + parseInt(sumOuShu, 10)
          + parseInt(sumJiShuChild1, 10) + parseInt(sumJiShuChild2, 10);
  let k = parseInt(sumTotal, 10) % 10 === 0 ? 10 : parseInt(sumTotal, 10) % 10;
  let luhn = 10 - k;
  if (lastNum === luhn) {
    return true;
  } else {
    return false;
  }
}

//校验车牌号格式是否正确
export function validateCarNumber(carNo) {
  const reg = /^[\u4e00-\u9fa5]{1}[a-zA-Z]{1}[a-zA-Z_0-9]{4}[a-zA-Z_0-9_\u4e00-\u9fa5]$/;
  return reg.test(carNo.trim());
}

// 校验是否是手机号或固定电话
export function validateMobile(mobileNum) {
  const isMob = /^((0\d{2,3}-{0,1}\d{7,8})|(1[123456789]\d{9}))$/.test(mobileNum.trim());
  return isMob;
}

/**
 * 校验身份证号是否合法
 * @param {*} cardNo 待校验的身份证号
 */
export function validatePaperId(cardNo)
 {
  //校验长度，类型
  if(isCardNo(cardNo) === false)
  {
   return false;
  }
  //检验位的检测
  if(checkParity(cardNo) === false)
  {
   return false;
  }
  return true;
 }
 //检查号码是否符合规范，包括长度，类型
 function isCardNo(obj)
 {
  const reg = /(^\d{15}$)|(^\d{17}(\d|X)$)/;
  if(reg.test(obj) === false)
  {
   return false;
  }
  return true;
 }
 
 //校验位的检测
 function checkParity(obj)
 {
  obj = changeFivteenToEighteen(obj);
  const len = obj.length;
  if(len === '18')
  {
   let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
   let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
   let cardTemp = 0, i, valnum;
   for(i = 0; i < 17; i ++)
   {
    cardTemp += obj.substr(i, 1) * arrInt[i];
   }
   valnum = arrCh[cardTemp % 11];
   if (valnum === obj.substr(17, 1))
   {
    return true;
   }
   return false;
  }
  return false;
 }

 //15位转18位身份证号
 function changeFivteenToEighteen(obj)
 {
  if(obj.length === '15')
  {
   let arrInt = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
   let arrCh = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
   let cardTemp = 0, i;
   obj = obj.substr(0, 6) + '19' + obj.substr(6, obj.length - 6);
   for(i = 0; i < 17; i ++)
   {
    cardTemp += obj.substr(i, 1) * arrInt[i];
   }
   obj += arrCh[cardTemp % 11];
   return obj;
  }
  return obj;
 }

 
// 是否是生产环境
export const isOnline = window.location.href.indexOf('test.tf56.com') === -1 && !/^http(s)?:\/\/localhost/.test(window.location.href) && !/^http(s)?:\/\/[0-9]+/.test(window.location.href);

// 手机号脱敏
export const mobileNumberChange = str => {
  return str.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
};

export function clearCookie(key) {
  document.cookie = `${key}=;expires=0;path=/;domain=tf56.com`;
}

export function setTitle(title) {
  document.title = title;
}

//在开始触发时，会立即执行一次； 如果最后一次没有超过 wait 值，则不触发
export function throttle(func, wait) {
  var context, args;
  var previous = 0; // 初始的时间点，也是关键的时间点

  return function() {
      var now = +new Date();
      context = this;
      args = arguments;
      if (now - previous > wait) {
          func.apply(context, args);
          previous = now;
      }
  }
}



// WEBPACK FOOTER //
// ./src/utils/utils.js